export default [
  {
    path: "attendance",
    name: "monitoring-attendance",
    component: () =>
      import("@/views/monitoring/views/attendance/Attendance.vue"),
    meta: {
      section: 5,
      pageTitle: "Attendance",
      breadcrumb: [
        {
          text: "List",
        },
      ],
    },
  },
];
